// ABOUTME: safeReturnUrl — the only check deciding whether a URL may be used as a post-login return target.
// ABOUTME: In-app paths only: a return URL travels through the OAuth state, so anything else would be an open redirect.

export function safeReturnUrl(raw: string | null | undefined): string | null {
  // angular-oauth2-oidc encodeURIComponent()s the custom state on the way out and returns it
  // undecoded in oauthService.state. Decode BEFORE validating, or %2F%2Fevil.example would pass
  // the '//' check and only turn protocol-relative afterwards.
  let url: string;
  try {
    url = decodeURIComponent(raw ?? '');
  } catch {
    return null;
  }
  if (!url || url === '/' || !url.startsWith('/') || url.startsWith('//') || url.includes('\\')) {
    return null;
  }
  // Returning to an auth route would restart the login flow.
  return url.startsWith('/auth/') ? null : url;
}
